import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategorySection() {
  return (
    <section className="py-20 md:py-28 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-4">
            ASMR 分类
          </span>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-4">
            探索不同的<strong className="text-primary-600">助眠声音</strong>
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            每个人对声音的感知不同，找到最适合您的 ASMR 触发音类型，开启专属助眠之旅
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category?tab=${cat.slug}`}
              className="group relative rounded-2xl overflow-hidden aspect-[4/3] block no-underline cursor-pointer"
            >
              <img
                src={cat.image}
                alt={`${cat.name} ASMR`}
                title={`${cat.name} ASMR 助眠音频`}
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-5">
                <div className="flex items-center gap-2 mb-2">
                  <span className="w-8 h-8 flex items-center justify-center rounded-full bg-background-50/20 backdrop-blur-sm">
                    <i className={`${cat.icon} text-background-50 text-sm`}></i>
                  </span>
                  <h3 className="text-lg font-heading font-semibold text-background-50">
                    {cat.name}
                  </h3>
                </div>
                <p className="text-xs text-background-50/75 line-clamp-2 mb-2">
                  {cat.description}
                </p>
                <span className="text-xs text-background-50/60">
                  {cat.articleCount} 篇内容
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}